
class CapViewRoutePullList {
  constructor(config) {
    this.config = config
  }
  
  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_route_pull_list'
}

function create(config) {
  return new CapViewRoutePullList(config)
}

export default {
  key,
  create,
}
